import styled from "styled-components";
import { Cores } from "../../styles/GlobalStyles";

export const FooterCss = styled.footer`
  width: 100%;
  background-color: ${Cores.primary};
  color: ${Cores.textDark};
  padding: 24px 0;
  margin-top: 40px;
  position: relative;
  overflow: hidden;
`;

export const InfoSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  gap: 32px;
  margin-bottom: 32px;
  width: 100%;

  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 16px;
    color: ${Cores.textDark};
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 24px;

    iframe {
      width: 100%;
    }
  }
`;

export const BusinessHours = styled.div`
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 16px;
    color: ${Cores.textDark};
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      display: flex;
      justify-content: space-between;
      padding-bottom: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .closed {
        color: #ff0000;
        font-weight: bold;
      }
    }
  }
`;

export const LocationMap = styled.div`
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 16px;
    color: ${Cores.textDark};
  }

  p {
    margin-top: 16px;
    font-size: 1rem;
    color: ${Cores.textDark};
  }

  iframe {
    border-radius: 8px;
    width: 100%;
    height: 250px;
  }
`;

export const SocialMedia = styled.div`
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 16px;
    color: ${Cores.textDark};
  }

  .social-links {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    gap: 12px;

    a {
      color: ${Cores.textDark};
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 1.1rem;
      transition: all 0.3s ease;
      padding: 8px;
      border-radius: 8px;

      &:hover {
        background: rgba(0, 0, 0, 0.05);
        transform: translateX(8px);
      }
    }
  }

  .contact-info {
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
      margin-bottom: 8px;
    }

    a {
      display: flex;
      align-items: center;
      gap: 12px;
      color: ${Cores.textDark};
      font-size: 1.1rem;
      transition: all 0.3s ease;
      padding: 8px;
      border-radius: 8px;

      &:hover {
        background: rgba(0, 0, 0, 0.05);
        transform: translateX(8px);
      }
    }
  }
`;

export const Copyright = styled.div`
  text-align: center;
  padding: 16px 24px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;

  p {
    font-size: 1rem;
    color: ${Cores.textDark};
  }
`;

export const Creator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 0.9rem;
  color: ${Cores.textDark};

  a {
    display: flex;
    align-items: center;
    gap: 8px;
    color: inherit;
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 6px 16px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.1);

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: translateY(-2px);
    }

    .dev-logo {
      border-radius: 50%;
      object-fit: cover;
    }

    .dev-title {
      font-size: 0.8rem;
      opacity: 0.8;
      margin-left: 8px;
      padding-left: 8px;
      border-left: 1px solid rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: 768px) {
    a {
      flex-direction: column;
      text-align: center;
      padding: 8px;

      .dev-title {
        margin-left: 0;
        padding-left: 0;
        border-left: none;
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        padding-top: 6px;
        margin-top: 6px;
      }
    }
  }
`;
